
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.06 17.14"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M12.13 9.58H7.89V3.61h1v4.97h3.24v1zM0 11.35h6.52v1H0zM0 13.75h6.52v1H0zM0 16.14h6.52v1H0z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M16.06 7.48a7.48 7.48 0 1 0-15 0 7.87 7.87 0 0 0 .19 1.68h1a6.75 6.75 0 0 1-.15-1.68A6.48 6.48 0 1 1 8.85 14v1a7.48 7.48 0 0 0 7.21-7.52z"}})])])])
          )
        }
      }
    